<!-- @format -->

@if (targetStringWithoutMatches) {
  <transpile [content]="targetStringWithoutMatches" />
}
<!-- Prettier makes this multi-line, which causes whitespace between substrings in the UI -->
<!-- prettier-ignore -->
@for (substring of substrings; track substring) { @if (substring.mark) { <mark>{{ substring.content }}</mark> } @else {{{ substring.content }}}}
